import React from 'react';
import { Box, Switch, Typography } from '@mui/material';

export default function VarLabelToggle({
  checked = false,
  onChange,
  label = 'Etiketleri Göster',
  size = 'small',
  sx = {},
  typographyProps = {},
  switchProps = {},
}) {
  const handleChange = (event) => {
    const next = event.target.checked;
    if (typeof onChange === 'function') {
      onChange(next);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ...sx }}>
      <Switch
        size={size}
        checked={!!checked}
        onChange={handleChange}
        {...switchProps}
      />
      <Typography variant="body2" {...typographyProps}>
        {label}
      </Typography>
    </Box>
  );
}
